
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/121-130/blockType121';

const defaultSettings = {
  config: [
    {
      eventTitle: '',
      eventDescription: '',
      eventStart: '',
      urlSlug: '',
      offerId: '',
      ridCustomer: '',
      ridNoCustomer: '',
      tidCustomer: '',
      tidNoCustomer: '',
      broadcastId: '',
      color: '',
      tagId: '',
      finished: false,
    },
  ],
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({});
